var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"organization-box"},[_c('div',[_c('div',{staticClass:"organization-title",attrs:{"align":"center"}},[_vm._v("交流动态")]),_vm._v(" "),_vm._l((_vm.organizationList),function(item,index){return _c('div',{staticClass:"organization-list-item",on:{"click":function($event){return _vm.goNext(item)}}},[_vm._v(_vm._s(index))])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85d0f05a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicAside.vue
// module id = null
// module chunks = 